import { defaultTheme } from 'gd-design-library';


export const input = {
  ...defaultTheme.input,
  wrapper: {
    ...defaultTheme.input.wrapper,
    withGap: {
      ...defaultTheme.input.wrapper.withGap,
      gap: '0'
    }
  },
  input: {
    ...defaultTheme.input.input,
    default: {
      ...defaultTheme.input.input.default,
      fontSize: '14px'
    }
  },
  helper: {
    ...defaultTheme.input.helper,
    default: {
      ...defaultTheme.input.helper.default,
      md: {
        ...defaultTheme.input.helper.default.md,
        fontSize: '12px',
        '&:has(+ span > input[required]):after': {
          content: '" *"'
        }
      }
    }
  }
};
